import { render, staticRenderFns } from "./TerminateWithhold.vue?vue&type=template&id=011b23ca&scoped=true"
import script from "./TerminateWithhold.vue?vue&type=script&setup=true&lang=js"
export * from "./TerminateWithhold.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TerminateWithhold.vue?vue&type=style&index=0&id=011b23ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "011b23ca",
  null
  
)

export default component.exports